import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import VueMask from 'v-mask';
import store from './store';
import App from './pages/online-scheduling.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(VueMask);

// init app
const el = document.querySelector('#online-scheduling');
if (el) {
	new Vue({
		store,
		components: {
			app: App,
		},
	}).$mount('#online-scheduling');
}
